<template>
    <div class="field field--select" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
                <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <select
                    @change="updateValue"
                    :disabled="disabled">
                    <option
                        v-if="allowEmpty"
                        value=""
                        :selected="value === ''">
                        {{ initialText }}
                    </option>
                    <option
                        :value="option.key"
                        :selected="option.key === value"
                        v-for="(option, idx) in options">
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import BaseField from './BaseField'
    import HelpText from '../HelpText'

    /**
     * Select Field Component
     */
    export default {
        name: 'select-field',
        extends: BaseField,
        components: {
            HelpText
        },
        props: {
            options: {
                type: Array,
                required: false,
                default: () => []
            },
            initialText: {
                type: String,
                required: false,
                default: '-- Select --'
            },
            allowEmpty: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        methods: {
            updateValue (e) {
                let parsedValue = isNaN(parseInt(e.target.value))
                    ? e.target.value
                    : parseInt(e.target.value)
                this.$emit('updated', parsedValue)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/SelectField.vue